import { LoaderFunctionArgs } from 'react-router-dom';
import { api } from '../lib/api';
import { queryClient } from '../providers/query-client';

export async function claimsLoader() {
    const claims = await queryClient.fetchQuery({
        queryKey: ['claims'],
        queryFn: async () => {
            const { data } = await api.billing.getClaims();
            return data;
        },
    });
    return claims;
}

export async function claimsInboxLoader() {
    const claims = await queryClient.fetchQuery({
        queryKey: ['claims', 'inbox'],
        queryFn: async () => {
            const { data } = await api.stedi.getInboxTransactions();
            return data;
        },
    });
    return claims;
}

export async function claimTransactionLoader({ params }: LoaderFunctionArgs) {
    const claims = await queryClient.fetchQuery({
        queryKey: ['transaction', params.transactionId],
        queryFn: async () => {
            if (params.transactionId && params.year && params.branchId) {
                const { data } = await api.stedi.getInboxTransaction(params.transactionId, params.year, params.branchId);
                return data;
            }
        },
    });
    return claims;
}

export async function claimLoader({ params }: LoaderFunctionArgs) {
    const claim = await queryClient.fetchQuery({
        queryKey: ['claim', params.branchId, params.admissionId, params.id],
        queryFn: async () => {
            if (params.branchId && params.admissionId && params.id) {
                const { data } = await api.billing.getClaim(params.branchId, params.admissionId, params.id);
                return data;
            }
            return null;
        },
    });
    return claim;
}

export async function patientClaimsLoader({ params }: LoaderFunctionArgs) {
    const claims = await queryClient.fetchQuery({
        queryKey: ['patient', 'claims', 'admission', params.admissionId, 'branch', params.branchId],
        queryFn: async () => {
            if (params.branchId && params.admissionId) {
                const { data } = await api.billing.getPatientClaims(params.branchId, params.admissionId);
                return data;
            }
        },
    });
    return claims;
}
